export default __webpack_public_path__ + "static/media/34744.db444dc0.jpg";